<script setup lang="ts">
export type FilterTab = {
  name: string;
  value: string | number;
};

type Props = {
  tabs: FilterTab[];
  modelValue: string | number;
  size?: 'default' | 'small';
};

const props = defineProps<Props>();
const emit = defineEmits<{ 'update:modelValue': [value: string | number] }>();

function selectTab(value: string | number) {
  emit('update:modelValue', value);
}
</script>

<template>
  <div class="filter-tabs">
    <BaseFilterTabButton
      v-for="tab in props.tabs"
      :key="tab.value"
      :active="modelValue === tab.value"
      :label="tab.name"
      :size="props.size"
      @click="selectTab(tab.value)"
    />
  </div>
</template>

<style scoped>
.filter-tabs {
  display: flex;
  justify-content: start;
  overflow-x: auto;
  gap: 7.5px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  user-select: none;
}

.filter-tabs::-webkit-scrollbar {
  display: none;
}

@media (max-width: 1023px) {
  .filter-tabs {
    flex-wrap: nowrap;
  }
}
</style>
